<div class="hint-star">
  <mat-icon fontSet="fa" fontIcon="fa-star"></mat-icon>
  <ng-content> </ng-content>
</div>
